import ByBaReportsVue from '@/views/sic/by-ba-reports/by-ba-reports.vue';

const basePath = '/sic/by-ba-reports';
const role = 'sic'; // 角色身份

export const SIC_BY_BA_REPORTS_INDEX = 'sic-by-ba-reports-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ByBaReportsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_BY_BA_REPORTS_INDEX,
      component: () => import(
        /* webpackChunkName: "reports" */
        `@/views/${role}/by-ba-reports/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
